import axiosClient from "utils/axios";
import type { ApiResponse } from "types/api.types";
import type { DashboardSummaryData } from "../types/dashboard.types";

export type GetDashboardSummaryParams = {
  year?: number;
  month?: number;
};

export const getDashboardSummary = async (
  params?: GetDashboardSummaryParams,
) => {
  const response = await axiosClient.get<ApiResponse<DashboardSummaryData>>(
    "/dashboard/summary",
    { params },
  );
  return response.data;
};
